export default "__VITE_ASSET__DnWTJw_O__"